<template>
  <div class="z-banner">
    <!-- 首页高度改变 -->
    <!-- <div class="z_banner_content" :style="ishome?'':'height: 288px;'"> -->
    <div class="z_banner_content" style="height: 280px">
      <div class="z_nav">
        <div class="z_nav_content">
          <ul>
            <li @click="CheckNav('首页')">
              <router-link
                :class="NavName == '首页' ? 'z_a_selected' : ''"
                :to="deptId == null ? '/home':'/home?deptId='+deptId"
              >
                <svg-icon className="nav_icon" icon-class="nav_header1" />
                首 页
              </router-link>
            </li>
            <li @click="CheckNav('平台介绍')">
              <router-link
                :class="NavName == '平台介绍' ? 'z_a_selected' : ''"
                :to="deptId == null ? '/list?type=0&class=0&categoryId=01':'/list?type=0&class=0&categoryId=01&deptId='+deptId"
              >
                <svg-icon className="nav_icon" icon-class="nav_header2" />
                平台介绍
              </router-link>
            </li>
            <li @click="CheckNav('平台动态')">
              <router-link
                :class="NavName == '平台动态' ? 'z_a_selected' : ''"
                :to="deptId == null ? '/list?type=0&class=1&categoryId=02':'/list?type=0&class=1&categoryId=02&deptId='+deptId"
              >
                <svg-icon className="nav_icon" icon-class="nav_header3" />
                平台动态
              </router-link>
            </li>
            <li @click="CheckNav('公告公示')">
              <router-link
                :class="NavName == '公告公示' ? 'z_a_selected' : ''"
                :to="deptId == null ? '/list?type=2&class=2&noticeType=21':'/list?type=2&class=2&noticeType=21&deptId='+deptId"
              >
                <svg-icon className="nav_icon" icon-class="nav_header4" />
                公告公示
              </router-link>
            </li>
            <!--  :to="deptId == null ? '/list?type=2&class=公告公示&categoryId=21':'/list?type=2&class=公告公示&categoryId=21&deptId='+deptId" -->
            <li @click="CheckNav('近期开标')">
              <!-- /list?type=1&class=3 -->
              <router-link
                :class="NavName == '近期开标' ? 'z_a_selected' : ''"
                :to="deptId == null ? '/list?type=1&class=3':'/list?type=1&class=3&deptId='+deptId"
              >
                <svg-icon className="nav_icon" icon-class="nav_header7" />
                近期开标
              </router-link>
            </li>
            <li @click="CheckNav('政策法规')">
              <router-link
                :class="NavName == '政策法规' ? 'z_a_selected' : ''"
                :to="deptId == null ? '/list?type=0&class=4&categoryId=05':'/list?type=0&class=4&categoryId=05&deptId='+deptId"
              >
                <svg-icon className="nav_icon" icon-class="nav_header6" />
                政策法规
              </router-link>
            </li>
            <li @click="CheckNav('用户指引')">
              <router-link
                :class="NavName == '用户指引' ? 'z_a_selected' : ''"
                :to="deptId == null ? '/list?type=0&class=5&categoryId=09':'/list?type=0&class=5&categoryId=09&deptId='+deptId"
              >
                <svg-icon className="nav_icon" icon-class="nav_header5" />
                用户指引
              </router-link>
            </li>
            <!-- <li @click="CheckNav('常见问题')">
              <router-link
                :class="NavName == '常见问题' ? 'z_a_selected' : ''"
                :to="deptId == null ? '/list?type=0&class=5&categoryId=04':'/list?type=0&class=5&categoryId=04&deptId='+deptId"
              >
                <svg-icon className="nav_icon" icon-class="nav_header5" />
                常见问题
              </router-link>
            </li>

            <li @click="CheckNav('资料下载')">
              <router-link
                :class="NavName == '资料下载' ? 'z_a_selected' : ''"
                :to="deptId == null ? '/list?type=0&class=6&categoryId=07':'/list?type=0&class=6&categoryId=07&deptId='+deptId"
              >
                <svg-icon className="nav_icon" icon-class="nav_header8" />
                资料下载
              </router-link>
            </li> -->
            <li @click="CheckNav('诚信专栏')">
              <router-link
                :class="NavName == '诚信专栏' ? 'z_a_selected' : ''"
                :to="deptId == null ? '/list?type=3&class=7':'/list?type=3&class=7&deptId='+deptId"
              >
                <svg-icon className="nav_icon" icon-class="nav_header9" />
                诚信专栏
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <div class="z-header">
        <div class="z-header-message">
          <div style="float: left">
            <span class="hello">{{logotitle10}}</span>
          </div>
          <div style="float: right">
            <span class="hello">{{ DateStr }}</span>
            <a
              class="register"
              href="http://ygcg.nbcqjy.org:8061/page/register/registagreement.html"
              target="_blank"
            >
              <span>注册会员</span>
            </a>
          </div>
        </div>
      </div>

      <div class="z_brand">
        <div class="z_content">
          <!-- <div class="logo"></div> -->
          <div class="logotitle" style="margin-top: 50px;display: inline-block;">
            <span class="z_logimg" style="display:inline-block;vertical-align:top"><img style="height:60px" src="../../assets/logo_256.png" /></span>
            <div style="display: inline-block;text-align: center;">
            <span style="font-size: 31px;color: white;font-weight: bold;letter-spacing: 6px;text-shadow: rgb(151 151 151) 0px 2px 4px;display: inline-block;margin-left: 5px;">{{logotitle}}</span><br/>
            <span style="color: white;text-shadow: rgb(151 151 151) 0px 2px 4px;margin-top: -4px;font-size: 16px;display: inline-block;">{{logotitle2}}</span><br/>
            <span style="color: white;font-size:21px;display: inline-block;text-shadow: rgb(151 151 151) 0px 2px 4px;">{{logotitle3}}</span>
            </div>
          </div>
          <div action="" class="search_form">
            <input
              type="search"
              v-model="keyword"
              @keyup.enter = "Query"
              placeholder="输入关键字，搜索公告或新闻"
            />
            <a class="search_btn" @click="Query">搜 索</a>
          </div>
        </div>
      </div>

      <div class="z_bg_img" :style="logbackgroundimgurl+bgimgcss"></div>
      <!-- :style="'background-image:url('+logbackgroundimgurl+')'" -->
    </div>
  </div>
</template>
<script>
import bgImg from "../../assets/bg_1440_0_1011.png"
import bgImg2 from "../../assets/bg_1440_0_1012.png"
import bgImg3 from "../../assets/bg_1440_0_1013.png"
import bgImg4 from "../../assets/bg_1440_0_9998.png"
import bgImg5 from "../../assets/bg_1440_0_1014.jpg"
import bgImg6 from "../../assets/bg_1440_0_1015.jpg"
import bgImg7 from "../../assets/bg_1440_0_1016.jpg"
import moment from "moment";
import { mapMutations } from "vuex";
import {
  GetDeptInfo
} from "@/api/Home";
export default {
  data() {
    return {
      // checkNav: "",
      keyword: "",
      deptId:"",
      logotitle:"宁波市阳光采购服务平台",
      logotitle2:"NINGBO SUNSHINE PURCHASING SERVICE PLATFORM",
      logotitle3:"—— 阳光、规范、专业、高效 ——",
      logotitle10:"您好，欢迎访问宁波市阳光采购服务平台",
      logbackgroundimgurl:'',
      bgimgcss:'',
      // logbackgroundimgurl:'/img/sider_nav_104a_2x.efb59088.png',
      // logbackgroundimgurl:bgImg,
    };
  },
  computed: {
    NavName() {
      return this.$store.state.nav.navName;
    },
    ishome() {
      return this.$route.meta.ishome;
    },
    DateStr() {
      let date = moment(new Date()).format("yyyy年MM月DD日");
      let week = moment(new Date()).day();
      switch (week) {
        case 1:
          date += " 星期一";
          break;
        case 2:
          date += " 星期二";
          break;
        case 3:
          date += " 星期三";
          break;
        case 4:
          date += " 星期四";
          break;
        case 5:
          date += " 星期五";
          break;
        case 6:
          date += " 星期六";
          break;
        case 0:
          date += " 星期日";
          break;
      }
      return date;
    },
  },
  mounted(){
    const query = this.$route.query;
    this.deptId = query.deptId; 
    // if(this.deptId!=null){
      this.GetDeptInfo();
    // }
  },
  methods: {
    ...mapMutations(["SET_NAV_NAME"]),
    GetWeek() {
      let week = moment(new Date()).day();
      switch (week) {
        case 1:
          return " 星期一";
        case 2:
          return " 星期二";
        case 3:
          return " 星期三";
        case 4:
          return " 星期四";
        case 5:
          return " 星期五";
        case 6:
          return " 星期六";
        case 0:
          return " 星期日";
      }
    },
    GetDeptInfo() {
      let param = {};
      param.DeptId = this.deptId;
      GetDeptInfo(param).then((res) => {
        if(res.data.deptInfo){
        this.logotitle = res.data.deptInfo.item.deptTitle;
        this.logotitle10 ="您好，欢迎访问"+res.data.deptInfo.item.deptTitle;
        // console.log(res.data.deptInfo.item.deptId);
        if(res.data.deptInfo.item.deptId==1011){
          this.logbackgroundimgurl = 'background-image:url('+bgImg+');';
          this.bgimgcss = 'background-position: 0px -200px;'
        }else if(res.data.deptInfo.item.deptId==1012){
          this.logbackgroundimgurl = 'background-image:url('+bgImg2+');';
          this.bgimgcss = 'padding-bottom: 18%;width: 1903px;background-size: 100% 98%;background-position: 0px -30px;'
        }else if(res.data.deptInfo.item.deptId==1013){
          this.logbackgroundimgurl = 'background-image:url('+bgImg3+');';
          this.bgimgcss = 'padding-bottom: 18%;width: 1903px;background-size: 100% 98%;background-position: 0px -30px;'
        }else if(res.data.deptInfo.item.deptId==9998){
          this.logbackgroundimgurl = 'background-image:url('+bgImg4+');';
          this.bgimgcss = 'padding-bottom: 18%;width: 1903px;background-size: 100% 106%;background-position: 0px 0px;'
        }else if(res.data.deptInfo.item.deptId==1014){
          this.logbackgroundimgurl = 'background-image:url('+bgImg5+');';
          this.bgimgcss = 'padding-bottom: 18%;width: 1903px;background-size: 100% 106%;background-position: 0px 0px;'
        }else if(res.data.deptInfo.item.deptId==1015){
          this.logbackgroundimgurl = 'background-image:url('+bgImg6+');';
          this.bgimgcss = 'padding-bottom: 18%;width: 1903px;background-size: 100% 106%;background-position: 0px 0px;'
        }else if(res.data.deptInfo.item.deptId==1016){
          this.logbackgroundimgurl = 'background-image:url('+bgImg7+');';
          this.bgimgcss = 'padding-bottom: 18%;width: 1903px;background-size: 100% 106%;background-position: 0px 0px;'
        }
        }else{
          this.logbackgroundimgurl = '';
        }
      });
    },
    CheckNav(nav_name) {
      this.checkNav = nav_name;
      this.SET_NAV_NAME(nav_name);
      // console.log(this.NavName);
      // console.log(this.checkNav);
    },
    Query() {
      this.$router.push({
        path: "/list",
        query: { type: 4, keyword: this.keyword,deptId:this.deptId },
      });
    },
  },
  created() {
    // console.log(this.ishome);
  },
};
</script>
// <style lang="less" scoped>
// @import "./z-header.less";
</style>